import { useTranslation } from 'react-i18next';

type TracksProgressProps = {
  active: number;
  total: number;
};

export const TracksProgress = ({ active, total }: TracksProgressProps) => {
  const { t } = useTranslation();
  const percentage = total === 0 ? 0 : parseFloat(((active / total) * 100).toFixed(1));

  if (total === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 whitespace-nowrap px-3 text-xs">
      {t('sections.navigation.tracksActive', { count: active, total })}
      <div
        role="progressbar"
        aria-label="Track Progress"
        aria-valuenow={percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={`${percentage}%`}
        className="h-2 w-full overflow-hidden rounded-sm bg-border/60"
      >
        <div className="h-full rounded-sm bg-chart-1" style={{ width: `${percentage}%` }} aria-hidden="true" />
      </div>
    </div>
  );
};
